import React from "react";
import { Calendar, Clock, Video, ShieldCheck, Mail, MessageCircle } from "lucide-react";
import CTAButton from "./CTAButton";

export default function FinalCTA() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-[28px] border border-[rgba(196,255,61,0.4)] bg-gradient-to-b from-[#0e1410] to-[#0a0f0a] p-8 md:p-12 overflow-hidden text-center">
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-[radial-gradient(circle,rgba(196,255,61,0.15),transparent_60%)] blur-3xl pointer-events-none" />

          <div className="relative">
            <p className="text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-4">
              One Decision Away
            </p>
            <h2 className="display-font text-3xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] mb-5">
              <span className="text-white">Your Expertise Is Valuable.</span>
              <br />
              <span className="lime-box">Now Build The System That Scales It.</span>
            </h2>
            <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto mb-8">
              Join the <span className="text-white font-semibold">AI Money Machine System™</span> workshop and discover how to transform your expertise, content and authority into a more predictable client-acquisition engine.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-3 mb-8">
              <Chip icon={<Calendar className="w-4 h-4" />} label="Sun, 26 July" />
              <Chip icon={<Clock className="w-4 h-4" />} label="11:00 AM IST" />
              <Chip icon={<Video className="w-4 h-4" />} label="Live Online · Zoom" />
            </div>

            <CTAButton source="final_cta" size="xl">
              Build My AI Money Machine
            </CTAButton>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/55 text-xs md:text-sm">
              <span className="inline-flex items-center gap-1.5">
                <ShieldCheck className="w-4 h-4 text-[#C4FF3D]" /> Secure Razorpay checkout
              </span>
              <span className="inline-flex items-center gap-1.5">
                <Mail className="w-4 h-4 text-[#C4FF3D]" /> Joining link via email
              </span>
              <span className="inline-flex items-center gap-1.5">
                <MessageCircle className="w-4 h-4 text-[#C4FF3D]" /> WhatsApp reminders
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Chip({ icon, label }) {
  return (
    <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-[rgba(196,255,61,0.22)] bg-[#0a0f0a] text-white text-xs md:text-sm font-semibold">
      <span className="text-[#C4FF3D]">{icon}</span>
      {label}
    </div>
  );
}
